// extracted by mini-css-extract-plugin
module.exports = {"legendContainer":"style_legendContainer__1OT_2","legendItem":"style_legendItem__ZqKfF","legendKey":"style_legendKey__1xFAd","innerBarLegend":"style_innerBarLegend__21AF9"};